function isWeChatWeb() {
	var ua = navigator.userAgent.toLowerCase();
	var isWeixin = ua.indexOf('micromessenger') != -1;

	return isWeixin;
}

export default isWeChatWeb();
